import React, { useEffect, useState } from "react";
import LightText, { DarkBold, LightDark } from "../../Assets/CSS/Text";
import { Continuebtn } from "../../Assets/CSS/Button";
import '../../Assets/CSS/EmployeeOnboard.css'
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const EmployeeForm = ({ next }) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        designation: '',
        dateOfBirth: '',
        departmentId: "",
        email: '',
        countryCode: "+91",
        mobileNumber: '',
        documents: {
        }
    })
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [pageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0); // Page index starts at 0
    // const [selectedDepartment, setSelectedDepartment] = useState("")
    const documents = [
        { id: 1, label: "Aadhar card" },
        { id: 2, label: "Highest Qualification Certificate" },
        { id: 3, label: "Relieving Letter / Experience Certificate" },
        { id: 4, label: "PAN Card" },
        { id: 5, label: "Passport-size Photograph" },
    ];
    const [selectedDocs, setSelectedDocs] = useState({});
    const [mandatoryDocs, setMandatoryDocs] = useState({});
    const [departments, setDepartments] = useState([]);

    const leftDocs = documents.slice(0, 3);
    const rightDocs = documents.slice(3, 5);

    const renderRow = (doc) => (
        <div className="row align-items-center mb-3" key={doc.id}>
            <div className="col-8 d-flex align-items-center">
                <input
                    type="checkbox"
                    className="form-check-input me-2"
                    checked={selectedDocs[doc.id] || false}
                    onChange={() => {
                        const updatedChecked = !selectedDocs[doc.id];

                        setSelectedDocs(prev => ({
                            ...prev,
                            [doc.id]: updatedChecked
                        }));

                        setFormData(prev => ({
                            ...prev,
                            documents: {
                                ...prev.documents,
                                [doc.label]: {
                                    checked: updatedChecked,
                                    mandatory: prev.documents[doc.label]?.mandatory || false
                                }
                            }
                        }));
                    }}

                />
                <label style={LightDark}>{doc.label}</label>
            </div>

            <div className="col-4 text-center">
                <div className="form-check form-switch">
                    <input
                        className="form-check-input  mandatory-toggle"
                        type="checkbox"
                        disabled={!selectedDocs[doc.id]}
                        checked={mandatoryDocs[doc.id] || false}

                        onChange={() => {
                            const updatedMandatory = !mandatoryDocs[doc.id];

                            setMandatoryDocs(prev => ({
                                ...prev,
                                [doc.id]: updatedMandatory
                            }));

                            setFormData(prev => ({
                                ...prev,
                                documents: {
                                    ...prev.documents,
                                    [doc.label]: {
                                        checked: true,  // checkbox must be selected because toggle is enabled
                                        mandatory: updatedMandatory
                                    }
                                }
                            }));
                        }}

                    />
                </div>
            </div>
        </div>
    );
    // Fetch departments (GET API)
    const fetchDepartments = async (page = 0) => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token"); // or wherever you store it
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/depts?page=${page}&size=${pageSize}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            const { content = [], totalPages = 1 } = response.data;
            setDepartments(content);
            setTotalPages(totalPages);
            setCurrentPage(page);

        } catch (error) {
            console.error("Error fetching departments:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDepartments(currentPage);
    }, [currentPage]);


    const today = new Date();
    today.setFullYear(today.getFullYear() - 18);
    const maxDOB = today.toISOString().split("T")[0];

    // validation 
    // Only alphabets and space (for names, designation, department name, etc.)
    const onlyAlphabets = /^[A-Za-z\s]*$/;


    // Only numbers
    const onlyNumbers = /^\d*$/;
    const emailRegex = /^\S+@\S+\.\S+$/;

    const handleAlphabetChange = (field) => (e) => {
        const value = e.target.value;

        // Block numbers & special characters
        if (!onlyAlphabets.test(value)) return;

        setFormData(prev => ({ ...prev, [field]: value }));
        setErrors(prev => ({ ...prev, [field]: "" }));
    };
    const handleNumberChange = (field, maxLength) => (e) => {
        const value = e.target.value;

        // Allow only digits
        if (!onlyNumbers.test(value)) return;

        // Max length check
        if (maxLength && value.length > maxLength) return;

        setFormData(prev => ({ ...prev, [field]: value }));
        setErrors(prev => ({ ...prev, [field]: "" }));
    };
    const handleEmailChange = (e) => {
        const value = e.target.value;

        setFormData(prev => ({ ...prev, email: value }));

        // Live validation
        if (!value.trim()) {
            setErrors(prev => ({ ...prev, email: "Email is required" }));
        } else if (!emailRegex.test(value)) {
            setErrors(prev => ({ ...prev, email: "Enter a valid email" }));
        } else {
            setErrors(prev => ({ ...prev, email: "" }));
        }
    };


    const validateForm = () => {
        const errors = {};

        // FIRST NAME
        if (!formData.firstName.trim()) {
            errors.firstName = "First name is required";
        } else if (formData.firstName.length < 2) {
            errors.firstName = "First name must be at least 2 characters";
        } else if (formData.firstName.length > 50) {
            errors.firstName = "First name must be less than 50 characters";
        } else if (!/^[A-Za-z\s'-]+$/.test(formData.firstName)) {
            errors.firstName = "First name can contain only letters, spaces, - and '";
        }

        // LAST NAME
        if (!formData.lastName.trim()) {
            errors.lastName = "Last name is required";
        } else if (formData.lastName.length > 50) {
            errors.lastName = "Last name must be less than 50 characters";
        } else if (!/^[A-Za-z\s'-]+$/.test(formData.lastName)) {
            errors.lastName = "Last name can contain only letters, spaces, - and '";
        }

        // DESIGNATION
        if (!formData.designation.trim()) {
            errors.designation = "Designation is required";
        } else if (!/^[A-Za-z\s]+$/.test(formData.designation)) {
            errors.designation = "Designation should contain only alphabets";
        } else if (formData.designation.length > 50) {
            errors.designation = "Designation must be less than 50 characters";
        }

        if (!formData.departmentId) errors.departmentId = "Department is required";
        // if (!formData.dateOfBirth) errors.dateOfBirth = "Date of Birth is required";

        // else {
        //     const dob = new Date(formData.dateOfBirth);
        //     const today = new Date();

        //     const adultDate = new Date(
        //         dob.getFullYear() + 18,
        //         dob.getMonth(),
        //         dob.getDate()
        //     );

        //     if (adultDate > today) {
        //         errors.dateOfBirth = "Employee must be at least 18 years old";
        //     }
        // }
        // DATE OF BIRTH (18+ validation)
        if (!formData.dateOfBirth) {
            errors.dateOfBirth = "Date of Birth is required";
        } else {
            const dob = new Date(formData.dateOfBirth);
            const today = new Date();

            const adultDate = new Date(
                dob.getFullYear() + 18,
                dob.getMonth(),
                dob.getDate()
            );

            if (adultDate > today) {
                errors.dateOfBirth = "Employee must be at least 18 years old";
            }
        }


        if (!formData.email.trim()) {
            errors.email = "Email is required";
        }
        // must start with a letter and contain letters before @
        else if (!/^[A-Za-z][A-Za-z0-9._%+-]*@/.test(formData.email)) {
            errors.email = "Email must start with a letter and contain letters before @";
        }
        // full email format validation
        else if (!/^[A-Za-z][A-Za-z0-9._%+-]*@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(formData.email)) {
            errors.email = "Enter a valid email address";
        }
        else {
            const domain = formData.email.split("@")[1];

            // ❌ block if domain contains ANY uppercase letter
            if (/[A-Z]/.test(domain)) {
                errors.email = "Email domain must be in lowercase (gmail.com)";
            }
        }



        // MOBILE NUMBER (only digits, 10 length)
        if (!formData.mobileNumber.trim()) {
            errors.mobileNumber = "Mobile number is required";
        } else if (!/^\d{10}$/.test(formData.mobileNumber)) {
            errors.mobileNumber = "Enter 10 digit mobile number";
        }

        return errors;
    };



    const handlesubmit = async () => {
        const validationErrors = validateForm();
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            toast.error("Please fix the highlighted errors");
            return;
        }

        try {
            setLoading(true);
            const token = localStorage.getItem("token");


            const filteredDocs = {};

            Object.entries(formData.documents).forEach(([docName, doc]) => {
                if (doc.checked) {
                    // checkbox selected → include in payload
                    filteredDocs[docName] = doc.mandatory ? true : false;
                }
            });

            const payload = {
                ...formData,
                departmentId: Number(formData.departmentId),
                documents: filteredDocs
            };

            console.log("Final Payload:", payload);

            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/documents/onboarding-link`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "*/*",
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                toast.success("Link sent successfully!");
                navigate('/emp-onbaord')
                setFormData({
                    firstName: "",
                    lastName: "",
                    designation: "",
                    dateOfBirth: "",
                    email: "",
                    countryCode: "+91",
                    mobileNumber: "",
                    documents: {},
                });
                setSelectedDocs({});
                setMandatoryDocs({});
                setErrors({});

            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Server error occurred");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container">

            {/* NAME ROW */}
            <div className="row mb-3">
                <div className="col-md-4">
                    <label className="form-label" style={LightText}>
                        First Name<span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control"
                        style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                        value={formData.firstName}
                        // onChange={(e) => {
                        //     setFormData({ ...formData, firstName: e.target.value });

                        //     // Remove error for firstName
                        //     setErrors(prev => ({ ...prev, firstName: "" }));
                        // }}
                        onChange={handleAlphabetChange("firstName")}
                    />
                    {errors.firstName && (
                        <small className="text-danger">{errors.firstName}</small>
                    )}
                </div>

                <div className="col-md-4">
                    <label className="form-label" style={LightText}>
                        Last Name<span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control"
                        style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                        value={formData.lastName}
                        // onChange={(e) => {
                        //     setFormData({ ...formData, lastName: e.target.value });
                        //     setErrors(prev => ({ ...prev, lastName: "" }));
                        // }}
                        onChange={handleAlphabetChange("lastName")}

                    />
                    {errors.lastName && <small className="text-danger">{errors.lastName}</small>}

                </div>
            </div>

            {/* DESIGNATION & DEPARTMENT */}
            <div className="row mb-3">
                <div className="col-md-4">
                    <label className="form-label" style={LightText}>
                        Designation <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control"
                        style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                        value={formData.designation}
                        // onChange={(e) => {
                        //     setFormData({ ...formData, designation: e.target.value });
                        //     setErrors(prev => ({ ...prev, designation: "" }));
                        // }}
                        onChange={handleAlphabetChange("designation")}
                    />
                    {errors.designation && <small className="text-danger">{errors.designation}</small>}

                </div>


                <div className="col-md-4">
                    <label className="form-label" style={LightText}>
                        Department <span className="text-danger">*</span>
                    </label>

                    <select
                        className="form-control custom-select"
                        style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                        value={formData.departmentId} // keep it as string
                        onChange={(e) => {
                            setFormData(prev => ({
                                ...prev,
                                departmentId: e.target.value // store as string for select
                            }));
                            setErrors(prev => ({ ...prev, departmentId: "" }));
                        }}
                    >
                        <option value="">Select Department</option>
                        {departments.map((dept) => (
                            <option key={dept.departmentId} value={dept.departmentId.toString()}>
                                {dept.name}
                            </option>
                        ))}
                    </select>


                    {errors.departmentId && <small className="text-danger">{errors.departmentId}</small>}

                </div>

            </div>

            {/* DOB & EMAIL */}
            <div className="row mb-3">
                <div className="col-md-4">
                    <label className="form-label" style={LightText}>
                        Date of Birth <span className="text-danger">*</span>
                    </label>
                    <input type="date"
                        className="form-control"
                        style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                        max={maxDOB}
                        value={formData.dateOfBirth}
                        onChange={(e) => {
                            setFormData({ ...formData, dateOfBirth: e.target.value });
                            setErrors(prev => ({ ...prev, dateOfBirth: "" }));
                        }}
                         onClick={(e) => e.target.showPicker()}
                    />
                    {errors.dateOfBirth && <small className="text-danger">{errors.dateOfBirth}</small>}

                </div>

                <div className="col-md-4">
                    <label className="form-label" style={LightText}>
                        Personal Email <span className="text-danger">*</span>
                    </label>
                    <input type="email"
                        className="form-control"
                        style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                        value={formData.email}
                        // onChange={(e) => {
                        //     setFormData({ ...formData, email: e.target.value });
                        //     setErrors(prev => ({ ...prev, email: "" }));
                        // }}
                        onChange={handleEmailChange}
                    />
                    {errors.email && <small className="text-danger">{errors.email}</small>}

                </div>
            </div>

            {/* MOBILE NUMBER */}
            <div className="mb-3 col-md-4">
                <label className="form-label" style={LightText}>Mobile Number</label>
                <div className="input-group d-flex gap-2">
                    <select className="form-select"
                        value={formData.countryCode || "+91"}
                        onChange={(e) =>
                            setFormData({ ...formData, countryCode: e.target.value })
                        }
                        style={{ maxWidth: "100px", borderColor: "#C8C8C8", borderRadius: "10px" }}>
                        <option value="+91">+91</option>
                        <option value="+1">+1</option>
                        <option value="+44">+44</option>
                        <option value="+61">+61</option>
                        <option value="+971">+971</option>
                    </select>

                    <input type="text" className="form-control"
                        placeholder="Enter mobile number"
                        maxLength={10}
                        style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                        value={formData.mobileNumber}
                        // onChange={(e) => {
                        //     setFormData({ ...formData, mobileNumber: e.target.value });
                        //     setErrors(prev => ({ ...prev, mobileNumber: "" }));
                        // }}
                        onChange={handleNumberChange("mobileNumber", 10)}
                    />


                </div>
                {errors.mobileNumber && (
                    <small className="text-danger">{errors.mobileNumber}</small>
                )}
            </div>

            {/* DOCUMENT SECTION TITLE */}
            <div className="row fw-bold mb-2">
                <div className="col-md-4 col-6" style={LightText}>
                    Request documents <span className="text-danger">*</span>
                </div>
                <div className="col-md-4 col-6 text-start" style={LightText}>
                    Mandatory
                </div>
                <div className="col-4 text-center" style={LightText}>
                    Mandatory
                </div>
            </div>

            {/* DOCUMENT LIST */}
            <div className="row">
                <div className="col-md-6">{leftDocs.map(renderRow)}</div>
                <div className="col-md-6">{rightDocs.map(renderRow)}</div>
            </div>

            {/* CONTINUE BUTTON */}

            <button
                className="mt-5 mb-2 d-flex align-items-center justify-content-center gap-2"
                style={Continuebtn}
                onClick={handlesubmit}
                disabled={loading}  // disable when loading
            >
                {loading && (
                    <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                    ></span>
                )}
                {loading ? "Please wait..." : "Continue"}
            </button>

        </div>
    );
};




export default EmployeeForm